<template>
  <div style="padding:15px;">
    <el-form
      ref="form"
      :model="form"
      label-width="180px"
      :disabled="parentData.isDetail"
    >
      <!-- 上传 -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="上传证件" required>
            <ImgUpload
              :upload-config="{
                lebal: '实际承运人身份证人像面照片',
                prefix: 'identification',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
            />
            <ImgUpload
              :upload-config="{
                lebal: '实际承运人身份证国徽面照片',
                prefix: 'identificationBack',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
            />
            <ImgUpload
              :upload-config="{
                lebal: '实际承运人半身照',
                prefix: 'driver',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
            />
            <ImgUpload
              :upload-config="{
                lebal: '实际承运人驾驶证照片',
                prefix: 'driverLicense',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
            />
            <ImgUpload
              v-if="ctmsShow"
              :upload-config="{
                lebal: '从业资格证照片',
                prefix: 'workLicense',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
            />
            <ImgUpload
              :upload-config="{
                lebal: '车辆行驶证照片',
                prefix: 'vehicleLicense',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
            />
            <ImgUpload
              v-if="ctmsShow"
              :upload-config="{
                lebal: '道路运输证照片',
                prefix: 'roadTransportCertificate',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
            />
            <ImgUpload
              v-if="ctmsShow"
              :upload-config="{
                lebal: '道路经营许可证照片',
                prefix: 'roadPermitNumber',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
            />
            <ImgUpload
              :upload-config="{
                lebal: '车辆照片',
                prefix: 'vehicle',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
            />
            <ImgUpload
              :upload-config="{
                lebal: '车主声明',
                prefix: 'state',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
            />
            <ImgUpload
              v-if="form.isLinked == 1"
              :upload-config="{
                lebal: '挂靠协议照片',
                prefix: 'depenDeal',
                form: form,
                suffix: 'Img',
                isRequired: false
              }"
              :parent-data="parentData"
              :required="false"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 必填 -->
      <el-row>
        <el-col :span="12">
          <el-form-item label="姓名" prop="name">
            <!-- 解决自动填充问题 -->
            <!-- <el-input type="text" style="position: fixed; bottom: -9999px;"></el-input> -->
            <el-input v-model="form.name" placeholder="请输入姓名" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号" prop="phone">
            <el-input
              v-model="form.phone"
              placeholder="请输入手机号"
              autocomplete="off"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="密码" prop="password">
            <!-- 解决自动填充问题 -->
            <el-input
              type="password"
              style="position: fixed; bottom: -9999px;"
            />
            <el-input
              v-model="form.password"
              type="password"
              autocomplete="new-password"
              placeholder="请输入密码，默认abcd1234"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身份证号" prop="identificationNumber">
            <el-input
              v-model="form.identificationNumber"
              placeholder="请输入身份证号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所在区域" prop="areaList">
            <el-cascader
              v-model="form.areaList"
              :options="parentData.areaOptions"
              :props="{
                value: 'countyCode',
                label: 'countyName',
                children: 'children'
              }"
              @change="changeAreaList"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址" prop="homeAddress">
            <el-input v-model="form.homeAddress" placeholder="请输入详细地址" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工作单位" prop="workCompany">
            <el-input v-model="form.workCompany" placeholder="请输入工作单位" />
          </el-form-item>
        </el-col>
        <el-col v-if="ctmsShow" :span="12">
          <el-form-item label="从业资格证号" prop="workLicense">
            <el-input
              v-model="form.workLicense"
              placeholder="请输入从业资格证号"
            />
            <div class="gray">
              总质量4.5吨及以下普通货运车辆从事普通货物运输经营的驾驶员可填驾驶员身份证前6位+000000000000
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车牌号" prop="licenseNumber">
            <el-input v-model="form.licenseNumber" placeholder="请输入车牌号" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车牌颜色" prop="vehicleLicenseColor">
            <el-input
              v-model="form.vehicleLicenseColorName"
              placeholder="请输入车牌颜色"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆类型" prop="classificationCode">
            <el-input
              v-model="form.classificationCodeName"
              placeholder="车辆类型"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="ctmsShow" :span="12">
          <el-form-item
            label="车辆道路运输证号"
            prop="roadTransportCertificateNumber"
          >
            <el-input
              v-model="form.roadTransportCertificateNumber"
              placeholder="请输入车辆道路运输证号"
            />
            <div class="gray">
              总质量4.5吨及以下普通货运车辆可填车籍地6位行政区代码+000000
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆总重量" prop="totalWeight">
            <el-input v-model="form.totalWeight" placeholder="车辆总重量" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆可载重量" prop="loadWeight">
            <el-input v-model="form.loadWeight" placeholder="车辆可载重量" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆长度" prop="length">
            <el-input v-model="form.length" placeholder="请选择车辆长度" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆宽度" prop="width">
            <el-input v-model="form.width" placeholder="请选择车辆宽度" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆高度" prop="height">
            <el-input v-model="form.height" placeholder="请选择车辆高度" />
          </el-form-item>
        </el-col>
        <el-col v-if="ctmsShow" :span="12">
          <el-form-item label="道路经营许可证号" prop="roadPermitNumber">
            <el-input
              v-model="form.roadPermitNumber"
              placeholder="请输入道路经营许可证号"
            />
            <div class="gray">
              总质量4.5吨及以下普通货运车辆的可填车籍地6位行政区域代码+000000
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆能源类型" prop="vehicleEnergyType">
            <el-input
              v-model="form.vehicleEnergyTypeName"
              placeholder="请选择车辆能源类型"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否挂靠车辆" prop="isLinked">
            <el-select v-model="form.isLinked" placeholder="请选择" clearable>
              <el-option
                v-for="item in isLinkedOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆所有人" prop="owner">
            <el-input v-model="form.owner" placeholder="" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆实际所有人" prop="realOwner">
            <el-input v-model="form.realOwner" placeholder="" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 总重量<=4.5吨(必填) -->
      <el-row>
        <el-col :span="12">
          <el-form-item label="总重量<=4.5吨(必填)">
            <el-switch v-model="showExtra" />
          </el-form-item>
        </el-col>
        <el-col v-if="!ctmsShow" :span="12">
          <el-form-item label="年审时间" prop="annualReviewTime">
            <el-date-picker
              v-model="form.annualReviewTime"
              type="date"
              placeholder="请选择年审时间"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :hidden="!showExtra">
        <el-col :span="12">
          <el-form-item label="准驾车型" prop="vehicleClass">
            <el-input
              v-model="form.vehicleClass"
              placeholder="请输入驾驶证发证机关"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="驾驶证发证机关"
            prop="driverIssuingOrganizations"
          >
            <el-input
              v-model="form.driverIssuingOrganizations"
              placeholder="请输入驾驶证发证机关"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="驾驶证有效期自" prop="driverLicenseFromDate">
            <el-date-picker
              v-model="form.driverLicenseFromDate"
              type="date"
              placeholder="请选择驾驶证有效期开始日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="驾驶证有效期至" prop="driverLicenseDueDate">
            <el-date-picker
              v-model="form.driverLicenseDueDate"
              :class="form.hasDriverDueDate ? 'disabledhide' : ''"
              type="date"
              placeholder="请选择驾驶证有效期结束日期"
              value-format="yyyy-MM-dd"
              clearable
              :disabled="form.hasDriverDueDate"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox
              v-model="form.hasDriverDueDate"
              @change="
                value => {
                  this.$set(
                    form,
                    'driverLicenseDueDate',
                    value ? '9999-12-31' : ''
                  );
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆所有人" prop="owner">
            <el-input v-model="form.owner" placeholder="请输入车辆所有人" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆使用性质" prop="useCharacter">
            <el-input
              v-model="form.useCharacter"
              placeholder="请输入车辆使用性质"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆识别码VIN" prop="vin">
            <el-input v-model="form.vin" placeholder="请输入车辆识别码VIN" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发证机关" prop="vehicleIssuingOrganizations">
            <el-input
              v-model="form.vehicleIssuingOrganizations"
              placeholder="请输入发证机关"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册日期" prop="registerDate">
            <el-date-picker
              v-model="form.registerDate"
              type="date"
              placeholder="请选择注册日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发证日期" prop="issueDate">
            <el-date-picker
              v-model="form.issueDate"
              type="date"
              placeholder="请选择发证日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 选填 -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="非必填项">
            <el-switch v-model="otherItems" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="otherItems">
        <el-col v-if="ctmsShow" :span="12">
          <el-form-item label="从业资格证到期日期" prop="workLicenseDueDate">
            <el-date-picker
              v-model="form.workLicenseDueDate"
              type="date"
              placeholder="请选择从业资格证到期日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="驾驶证号" prop="driverLicense">
            <el-input
              v-model="form.driverLicense"
              placeholder="请输入驾驶证号"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="ctmsShow" :span="12">
          <el-form-item
            label="道路运输证到期日期"
            prop="roadTransportCertificateDate"
          >
            <el-date-picker
              v-model="form.roadTransportCertificateDate"
              type="date"
              placeholder="请选择道路运输证到期日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车身自重" prop="selfRespect">
            <el-input v-model="form.selfRespect" placeholder="请输入车身自重" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行驶证号" prop="vehicleLicense">
            <el-input
              v-model="form.vehicleLicense"
              placeholder="请输入行驶证号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆行驶证到期日期" prop="vehicleLicenseDueDate">
            <el-date-picker
              v-model="form.vehicleLicenseDueDate"
              type="date"
              placeholder="请选择车辆行驶证到期日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="定位来源" prop="locationSource">
            <el-select v-model="form.locationSource" placeholder="">
              <el-option
                v-for="item in locationSourceOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否挂车" prop="isHasTrailer">
            <el-select v-model="form.isHasTrailer" placeholder="请选择">
              <el-option
                v-for="item in isHasTrailerOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆实际所有人联系电话">
            <el-input v-model="form.realOwnerPhone" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <ImgUpload
              v-if="compTrailer"
              :upload-config="{
                lebal: '挂车行驶证照片',
                prefix: 'trailerVehicleLicense',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
            />
            <ImgUpload
              v-if="compTrailer"
              :upload-config="{
                lebal: '挂车照片',
                prefix: 'trailerVehicle',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
            />
            <ImgUpload
              v-if="compTrailer"
              :upload-config="{
                lebal: '挂车道路运输证照片',
                prefix: 'trailerRoadTransportCertificate',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
            />
            <ImgUpload
              :upload-config="{
                lebal: '安全责任险照片',
                prefix: 'safeDutyInsure',
                form: form,
                suffix: 'Img',
                isRequired: false
              }"
              :parent-data="parentData"
              :required="false"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="compTrailer" :span="12">
          <el-form-item label="挂车车牌号" prop="trailerNum">
            <el-input
              v-model="form.trailerNum"
              placeholder="请输入挂车车牌号"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="compTrailer" :span="12">
          <el-form-item label="挂车道路运输证号" prop="trailerRoadTransport">
            <el-input
              v-model="form.trailerRoadTransport"
              placeholder="请输入车辆道路运输证号"
            />
            <div class="gray">
              总质量4.5吨及以下普通货运车辆可填车籍地6位行政区代码+000000
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import ImgUpload from "@/components/ImgUpload";
import request from "@/utils/request";
export default {
  name: "DriverEdit",
  components: {
    ImgUpload
  },
  data() {
    return {
      showExtra: true,
      ctmsShow: true,
      otherItems: true,
      linkageInvalid: true,
      form: {
        driverType: 0,
        workLicenseImg: "",
        driverImg: "",
        driverLicenseImg: "",
        identificationBackImg: "",
        identificationImg: "",
        trailerVehicleLicenseImg: "",
        trailerRoadTransportCertificateImg: "",
        trailerVehicleImg: "",
        roadTransportCertificateImg: "",
        vehicleImg: "",
        vehicleLicenseImg: "",
        roadPermitNumberImg: "",
        locationSource: "0",
        isLinked: 0,
        vehicleDTO: {}
      },
      // 挂车
      isHasTrailerOptions: [
        { label: "无", value: 0 },
        { label: "有", value: 1 }
      ],
      // 挂靠车辆
      isLinkedOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 定位来源
      locationSourceOptions: [
        { label: "北斗定位", value: "0" },
        { label: "APP端", value: "1" }
      ],
      parentData: {
        isDetail: true,
        areaOptions: this.$store.state.components.areaOptions
      }
    };
  },
  computed: {
    compTrailer() {
      return this.form.isHasTrailer === 1 ? true : false;
    }
  },
  created() {
    const query = this.$route.query;
    this.form = {};
    if (query) {
      request({
        url: `/ntocc-basic-api/driver/service_info`,
        method: "get",
        params: query
      }).then(response => {
        this.form = Object.assign({}, response.data, response.data.vehicleVO);
        this.$set(this.form, "areaList", []);
        this.$set(
          this.form,
          "hasDriverDueDate",
          this.form.driverLicenseDueDate == "9999-12-31"
        );
        if (
          this.form.provinceCode &&
          this.form.cityCode &&
          this.form.countyCode
        ) {
          this.form.areaList.push(
            this.form.provinceCode,
            this.form.cityCode,
            this.form.countyCode
          );
        }
      });
      // ?app_id=1&sign_key=81436655dbad50ecff6b2024dbfd38e7&time=3&fwfuuid=ed84a961b4cc49a8814fe64d73075eb6
    }
  },
  methods: {
    // 区域切换
    changeAreaList(value) {
      if (value.length > 0) {
        this.form.provinceCode = value[0];
        this.form.cityCode = value[1];
        this.form.countyCode = value[2];
      } else {
        this.form.provinceCode = "";
        this.form.cityCode = "";
        this.form.countyCode = "";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.el-date-editor {
  width: 100%;
}
</style>
